// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayGeneralForm_wrapper__zITNP","submitWrapper":"EditHolidayGeneralForm_submitWrapper__zTGPn"};